export const POSSIBLE_WEEKS_OF_BATTLE = [
    {weekCode: 1, displayFriendlyWeek: 'Week One'},
    {weekCode: 2, displayFriendlyWeek: 'Week Two'},
    {weekCode: 3, displayFriendlyWeek: 'Week Three'},
    {weekCode: 4, displayFriendlyWeek: 'Week Four'},
    {weekCode: 5, displayFriendlyWeek: 'Finals'}
];